import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';
import store from '../../store';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      id: item.id,
      key: item.id,
      domain: item.domain,
      is_verified: item.is_verified,
      dns_TXT_record: item.dns_TXT_record,
      meta_tag: item.meta_tag,
      current_network: item.current_network,
      current_network_commission_rate: item.current_network_commission_rate,
      preferred_network: item.preferred_network,
      preferred_network_choices: item.preferred_network_choices
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getMerchants({ payload: { signal, curr_page } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.store_domains.list,
      params: { page: curr_page },
      signal
    });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      merchants: data.results,
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.previous
    };
    yield put(actions.getMerchantsDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getMerchantsFailed,
      endpoint: api.store_domains.list.url
    });
  }
}

function* deleteMerchant({ payload: { values, onSuccess } }) {
  const { getState, dispatch } = store;

  try {
    const { data } = yield call(fetch, { api: api.store_domains.delete, id: values.id });

    dispatch(actions.getMerchantsRequest({ curr_page: getState().merchants.curr_page }));

    onSuccess && onSuccess();
    yield put(actions.deleteMerchantDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.deleteMerchantFailed,
      endpoint: api.store_domains.delete.url
    });
  }
}

export const getMerchantsSaga = takeEvery(types.GET_MERCHANTS_REQUEST, getMerchants);
export const deleteMerchantSaga = takeEvery(types.DELETE_MERCHANT_REQUEST, deleteMerchant);